import { TFunction } from 'i18next';
import {
  BalanceItem,
  Balance,
} from '@/features/Profile/sections/Balance/api/types';

export function getBalances(
  balance: Balance | undefined,
  t: TFunction
): BalanceItem[] {
  return [
    {
      title: t('pages.cabinet.main_balance'),
      subtitle: t('pages.cabinet.main_balance_subtitle'),
      amount: balance?.cash,
    },
    {
      title: t('pages.cabinet.package_balance'),
      subtitle: t('pages.cabinet.package_balance_subtitle'),
      amount: balance?.pack,
    },
    {
      title: t('pages.cabinet.bonus_balance'),
      subtitle: t('pages.cabinet.bonus_balance_subtitle'),
      amount: balance?.bonus,
    },
    {
      title: t('pages.cabinet.private_account'),
      subtitle: t('pages.cabinet.sum_of_all_balances'),
      amount: balance?.total,
    },
  ];
}

export function getAdsBalance(
  paidAds: number | undefined,
  t: TFunction
): BalanceItem {
  return {
    title: t('pages.cabinet.ads_balance'),
    subtitle: t('pages.cabinet.remaining_ads_in_package'),
    amount: paidAds,
  };
}
